/**
 * @flow
 */
import * as React from 'react';
import Header from './Header/index';
import Footer from './Footer';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Row, Col, Container } from 'reactstrap';

const styles = {
  container: {
    paddingTop: 20,
    paddingBottom: 100,
  },
};

type Props = {
  children: React.ChildrenArray<*>
}

@observer
export default class Main extends React.Component<Props, void> {
  @observable loading: boolean = false;

  componentWillMount() {
    // this.loadSettings();
  }

  // async loadSettings() {
  //   try {
  //     await Settings.load();
  //   } finally {
  //     this.setState({ loading: false });
  //   }
  // }

  handleLangChanged = (lang: string) => {
    window.location.reload();
  };

  render() {
    if (this.loading) {
      return (
        <div className="loading-container">
          <div className="loading-text">{'Die Analyse-Webseite wird geladen'}</div>
        </div>
      );
    }

    return (
      <div>
        <Header onLangChanged={this.handleLangChanged} />
        <Container>
          <Row style={styles.container}>
            <Col>{this.props.children}</Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Layout/Main.js